import { createComponent } from "@helpers/admin";
import ArchStandaloneSectionComponent from "@template/blocks/ArchStandaloneSection/component";

export const ArchStandalone = createComponent({
  label: "Arch",
  component: ArchStandaloneSectionComponent,
  fields: {
    color: {
      label: "Arch Color",
      type: "select",
      options: [
        { label: "White", value: "white" },
        { label: "Grey", value: "grey" },
      ],
    },
    background: {
      label: "Background Color",
      type: "select",
      options: [
        { label: "None", value: undefined },
        { label: "Dark", value: "dark" },
        { label: "Grey", value: "grey" },
      ],
    },
    withPadding: {
      label: "With Padding",
      type: "boolean",
    },
  },
});
